import { contactAddApi } from "../../api/contact/contactAddApi"

type PayloadShape = Parameters<typeof contactAddApi>[0]

export async function contactAddService(payload: PayloadShape, token: string) {
	if (!payload.mobile) payload.mobile = undefined
	return await contactAddApi(payload, token)
}
